 import {Tooltip} from 'bootstrap';
 const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))

 import Swiper, { Navigation, Pagination,EffectFade,Autoplay } from 'swiper';
 // import Swiper and modules styles
 import 'swiper/css';
 import 'swiper/css/pagination';
 import 'swiper/css/navigation';
 // init Swiper:
 const swiper = new Swiper(".mySwiper", {
    modules:[Navigation,EffectFade,Autoplay],
    centeredSlides: true,
    // effect: 'fade',
    loop: true,
    autoplay: {
        delay: 2800,
        disableOnInteraction: true,
      },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const post = new Swiper(".Swiperpost", {
    modules:[Pagination,EffectFade,Autoplay],
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });